import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DioService } from '../../../shared/services/dio.service';
import { GetServicePointsResponse, GetServicePointsRequest, PostServedServicePointRequest, GetServicePointsModel } from '../../../shared/models/dio.models';

@Component({
  templateUrl: 'new-visit-service-point.component.html',
  styleUrls: ['./new-visit-service-point.component.scss']
})
export class NewVisitServicePointComponent implements OnInit {

  servicePointsResponse: GetServicePointsResponse | null = null;
  selectedModel: GetServicePointsModel | null = null;

  constructor(
    private dioService: DioService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadScheduledServicePoints();
  }

  loadScheduledServicePoints() {
    const request: GetServicePointsRequest = {};
    this.dioService.getServicePoints(request).subscribe((response: GetServicePointsResponse) => {
      this.servicePointsResponse = response;
    });
  }

  navigateToServicePointManager() {
    this.router.navigate(['/service-point-manager']);
  }

  proceed() {
    if (!this.selectedModel || !this.selectedModel.id) {
      return;
    }
    const request: PostServedServicePointRequest = { dioServicePointId: this.selectedModel.id };
    this.dioService.postServedServicePoint(request).subscribe(result => {
      if (result && result.id) {
        this.router.navigate([`/visited-service-point/${result.id}`]);
      }
    });
  }
}